import { useState } from "react";
import "./App.css";
import "../node_modules/flag-icon-css/css/flag-icons.min.css";
import TopHeader from "./Components/TopHeader";
import Banner from "./Components/Banner";
import Footer from "./Components/Footer";
import Navbar from "./Components/Navbar";
import Alert from "./Components/Alert";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomeAbout from "./Components/HomeAbout";
import ServiceSection from "./Components/ServiceSection";
import Industries from "./Components/Industries";
import PageBanner from "./Components/PageBanner";
import ScrollToTop from "./Components/ScrollToTop";
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "flag-icon-css/css/flag-icons.min.css"
import Portfolio from "./Components/Portfolio";
import PortfolioDetails from "./Components/PortfolioDetails";
import PortfolioList from "./Components/PortfolioList";
import Contact from "./Components/Contact";
function App() {
  useEffect(() => {
    AOS.init();
  }, []);
  const [mode, setMode] = useState("dark");
  const [modeName, setModeName] = useState("Enable Light");
  const [alert, setAlert] = useState(null);
  const showAlert = (message, type) => {
    setAlert({
      msg: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 1500);
  };
  const toggleMode = () => {
    if (mode === "light") {
      setMode("dark");
      document.body.style.backgroundColor = "#34353a";
      document.body.style.color = "white";
      setModeName("Enable Light");
      showAlert("Dark mode has been activated", "success");
    } else {
      setMode("light");
      document.body.style.backgroundColor = "white";
      document.body.style.color = "#34353a";
      setModeName("Enable Dark");
      showAlert("Light mode has been activated", "success");
    }
  };
  return (
    <div className={`App theme-${mode}`}>
      <Router>
        <ScrollToTop />
        <TopHeader
          emailImg="email.png"
          flagImg="flag.png"
          emailText="kohliarjun823@gmail.com"
          phoneText="+91 9990031433"
          topText="Contact : Monday - Friday | 10:00AM - 6:00PM(IST)"
          mode={mode}
        />
        <Navbar
          mode={mode}
          modeName={modeName}
          toggleMode={toggleMode}
          logoSrcBlack="logo.png"
          logoSrcWhite="logowhite.png"
          home="Home"
          portfolio="Portfolio"
          about="About Me"
          contact="Contact"
          emailImg="email.png"
          emailImg2="email2.png"
        />
        {/* <Navbar /> */}
        <Alert alert={alert} />
        <Routes>
          <Route
            exact
            path="/"
            element={
              <>
     <Banner
  mode={mode}
  image="profile.png"
  badge="Open to New Opportunities"
  heading="Hello, I'm"
  heading2="Arjun Singh"
  details="Senior Frontend Developer | Next.js | React | TypeScript | Tailwind CSS | 6+ Years of Professional Experience"
  buttonText="Let's Connect"
  serviceLink="/contact"
/>
                <HomeAbout
  mode={mode}
  aboutHeading="About Me"
  aboutSubHeading="Building Scalable Digital Experiences with Code, Creativity & Purpose"
  aboutPara1="I'm Arjun Singh, a Senior Frontend Developer with 6+ years of experience in web development, UI engineering, and building high-performance digital experiences. My journey began with UI/UX and web design, which gave me a strong eye for visual detail, user experience, and pixel-perfect implementation. Today, I specialize in transforming complex designs and ideas into scalable, responsive, and production-ready web applications using Next.js, React, TypeScript, and Tailwind CSS."
  aboutPara2="Throughout my career, I have worked on a wide range of projects, including corporate websites, enterprise platforms, marketing websites, role-based admin dashboards, and client portals. I've built and delivered projects such as CodeAegis, SmartCarrots, LBW11, and BNEA, while also contributing to 20+ dashboards and client projects. My work goes beyond building interfaces—I focus on clean component architecture, API integration, dynamic data-driven experiences, performance optimization, responsive design, and SEO-friendly development."
  aboutPara3="I enjoy solving real-world problems through thoughtful frontend engineering and collaboration. Whether I'm working closely with designers to achieve pixel-perfect accuracy, integrating APIs with backend teams, improving application performance, or building complex user workflows, my goal is always the same: to create reliable, intuitive, and meaningful digital experiences. I believe great frontend development is where strong engineering meets great design."
/>
               <ServiceSection
  mode={mode}
  skillsHeading="My Skills"
  skillsSubHeading="Technologies and tools I use to build scalable, high-performance digital experiences."
/>
                <Portfolio
                  mode={mode}
                  portfolioHeading="Portfolios"
                  portfolioSubHeading="Explore a collection of some diverse and innovative projects"
                />
                <Industries
  mode={mode}
  industriesHeading="Professional Experience"
  industriesSubHeading="A Journey of Growth, Design, and Frontend Engineering"
/>
                <Contact mode={mode} />
              </>
            }
          />
          <Route
            path="/about"
            element={
              <>
                <PageBanner
                  pageBannerHeading="About Me"
                  pageBannerSubHeading="Crafting Exceptional Digital Experiences Across Multiple Languages"
                />
                        <HomeAbout
  mode={mode}
  aboutHeading="About Me"
  aboutSubHeading="Building Scalable Digital Experiences with Code, Creativity & Purpose"
  aboutPara1="I'm Arjun Singh, a Senior Frontend Developer with 6+ years of experience in web development, UI engineering, and building high-performance digital experiences. My journey began with UI/UX and web design, which gave me a strong eye for visual detail, user experience, and pixel-perfect implementation. Today, I specialize in transforming complex designs and ideas into scalable, responsive, and production-ready web applications using Next.js, React, TypeScript, and Tailwind CSS."
  aboutPara2="Throughout my career, I have worked on a wide range of projects, including corporate websites, enterprise platforms, marketing websites, role-based admin dashboards, and client portals. I've built and delivered projects such as CodeAegis, SmartCarrots, LBW11, and BNEA, while also contributing to 20+ dashboards and client projects. My work goes beyond building interfaces—I focus on clean component architecture, API integration, dynamic data-driven experiences, performance optimization, responsive design, and SEO-friendly development."
  aboutPara3="I enjoy solving real-world problems through thoughtful frontend engineering and collaboration. Whether I'm working closely with designers to achieve pixel-perfect accuracy, integrating APIs with backend teams, improving application performance, or building complex user workflows, my goal is always the same: to create reliable, intuitive, and meaningful digital experiences. I believe great frontend development is where strong engineering meets great design."
/>
              </>
            }
          />
          <Route
            path="/portfolio-list"
            element={
              <>
                <PageBanner
                  pageBannerHeading="Portfolios"
                  pageBannerSubHeading="Explore a Collection of Diverse and Innovative Projects"
                />
                <PortfolioList />
              </>
            }
          />
          <Route
            path="/portfolio-details/:id"
            element={
              <>
                <PageBanner
                  pageBannerHeading="Portfolios"
                  pageBannerSubHeading="Instant Quote for Your Project Needs: Transparent, Affordable, and Reliable"
                />
                <PortfolioDetails mode={mode} />
              </>
            }
          />
           <Route
            path="/contact"
            element={
              <>
                <PageBanner
                  pageBannerHeading="Contact"
                  pageBannerSubHeading="Instant Quote for Your Project Needs: Transparent, Affordable, and Reliable"
                />
                <Contact mode={mode} />
              </>
            }
          />
        </Routes>
        <Footer mode={mode} logoSrcBlack="logo.png"
          logoSrcWhite="logowhite.png" />
      </Router>
    </div>
  );
}

export default App;
